<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_11246_15456)">
            <path
                d="M39.8594 67.9446V69.0865"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M39.8594 71.1987V72.3407"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M37.6602 70.1428H38.8021"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M40.9141 70.1428H42.056"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M47.2461 60.1267V62.2202"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M47.2461 66.0938V68.1873"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M43.2188 64.157H45.3085"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M49.1875 64.157H51.2773"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M74.4531 60.6902V62.5859"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M74.4531 66.105V68.0007"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M70.7969 64.3435H72.6926"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M76.207 64.3435H78.1065"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M83.6094 93.9403H88.9421V87.6709"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M88.9465 84.9315V83.4873H78.1094V89.4395"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M84.4878 73.2922H82.5734L78.8789 79.1661H88.1822L84.4878 73.2922Z"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M78.1094 88.7417H88.9465"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M81.6406 83.4873H85.2493C85.2493 84.1292 84.7268 84.6516 84.0849 84.6516H82.8049C82.1631 84.6516 81.6406 84.1292 81.6406 83.4873Z"
                class="primary-fill" />
            <path
                d="M81.6719 88.7417H85.2805C85.2805 89.3836 84.7581 89.906 84.1162 89.906H82.8362C82.1943 89.906 81.6719 89.3836 81.6719 88.7417Z"
                class="primary-fill" />
            <path
                d="M84.792 79.1663H82.2656V83.4877H84.792V79.1663Z"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M73.1714 85.4018L86.0236 95.918H61.2968H60.2893H35.5625L48.8327 85.0623"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M48.8327 85.0623L35.5625 95.918H86.0236L73.1714 85.4018"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M37.0914 100.124H35.7405C35.3039 100.124 34.9531 100.479 34.9531 100.911V108.125C34.9531 108.562 35.3076 108.912 35.7405 108.912H37.6064C38.043 108.912 38.3938 108.558 38.3938 108.125C38.3938 107.688 38.7483 107.338 39.1812 107.338H82.3318C82.7684 107.338 83.1192 107.692 83.1192 108.125C83.1192 108.562 83.4737 108.912 83.9066 108.912H85.7725C86.2091 108.912 86.5599 108.558 86.5599 108.125V100.911C86.5599 100.475 86.2054 100.124 85.7725 100.124H37.0914Z"
                class="primary-fill" />
            <path
                d="M35.5625 95.918H86.0236V100.497H35.5625V98.575"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M45.9453 87.4283V79.349C45.9453 75.453 49.1024 72.2959 52.9984 72.2959H68.7315C72.6275 72.2959 75.7846 75.453 75.7846 79.349V87.2529"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M64.8928 74.9006H53.3803C50.9061 74.9006 48.8984 76.8076 48.8984 79.1623"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M60.3797 88.6748C60.3797 88.6748 60.3872 88.6487 60.3909 88.6375C60.4096 88.5778 60.4245 88.5218 60.4394 88.4621C60.4394 88.4621 60.4394 88.4584 60.4394 88.4547C60.7753 87.1896 60.7417 85.8499 60.6073 84.7751C60.4543 83.5362 60.1745 82.6517 60.1745 82.6517C54.5805 81.1143 49.7218 82.5883 49.5277 82.6517H49.5202C49.5016 82.7115 49.4829 82.7674 49.4643 82.8271C49.4643 82.8383 49.4568 82.8495 49.4531 82.8607C49.4381 82.913 49.4232 82.9652 49.4083 83.0137C49.4083 83.0212 49.4045 83.0287 49.4008 83.0361C48.8485 85.0476 49.1172 87.2493 49.3336 88.4136C49.3336 88.4323 49.3411 88.4509 49.3448 88.4696C49.3448 88.4733 49.3448 88.4808 49.3448 88.4845C49.3896 88.7122 49.4269 88.895 49.4605 89.0219C49.468 89.0592 49.4792 89.0928 49.4829 89.1189C49.5016 89.1973 49.5128 89.2421 49.5128 89.2421H49.5202C49.5277 89.2421 49.5389 89.2458 49.5464 89.2495C49.5464 89.2495 49.5464 89.2495 49.5538 89.2495C49.5911 89.2607 49.6247 89.2682 49.662 89.2794C49.7031 89.2906 49.7441 89.3018 49.7852 89.313C49.8374 89.3279 49.8859 89.3391 49.9382 89.354C49.9755 89.3652 50.0166 89.3727 50.0539 89.3839C50.2405 89.4287 50.4271 89.4697 50.6136 89.5108C50.6472 89.5182 50.6771 89.5257 50.7107 89.5294C50.7666 89.5406 50.8264 89.5518 50.8823 89.563C50.9122 89.5705 50.942 89.5742 50.9756 89.5779C51.1734 89.6152 51.3712 89.6451 51.5727 89.675C51.5988 89.675 51.6212 89.6824 51.6473 89.6862C51.7071 89.6936 51.7705 89.7011 51.8302 89.7123C51.8563 89.7123 51.8825 89.7197 51.9123 89.7235C52.1138 89.7496 52.3153 89.7683 52.5169 89.7869C52.5392 89.7869 52.5616 89.7906 52.584 89.7944C52.6437 89.7981 52.7034 89.8056 52.7631 89.8093C52.7893 89.8093 52.8191 89.813 52.8452 89.8168C52.905 89.8205 52.9647 89.8242 53.0244 89.828C53.0393 89.828 53.0505 89.828 53.0654 89.828C53.1886 89.8354 53.3117 89.8429 53.4349 89.8466C53.461 89.8466 53.4834 89.8466 53.5095 89.8466C53.5655 89.8466 53.6252 89.8504 53.6812 89.8541C53.711 89.8541 53.7409 89.8541 53.7707 89.8541C53.8267 89.8541 53.8864 89.8541 53.9424 89.8578C53.9648 89.8578 53.9872 89.8578 54.0058 89.8578C54.1215 89.8578 54.2335 89.8615 54.3454 89.8615C54.3678 89.8615 54.3902 89.8615 54.4089 89.8615C54.4313 89.8615 54.4499 89.8615 54.4723 89.8615C57.4018 89.8615 59.8013 89.3167 60.1259 89.2421C60.1409 89.2421 60.1521 89.2346 60.1558 89.2346C60.1857 89.16 60.2118 89.0891 60.2379 89.0144C60.2566 88.9585 60.279 88.9025 60.2976 88.8502C60.2976 88.8428 60.3013 88.8353 60.3051 88.8278C60.3237 88.7719 60.3387 88.7196 60.3573 88.6636L60.3797 88.6748Z"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M67.4701 81.9577C64.2011 81.898 61.8613 82.607 61.7269 82.6518H61.7194C61.7008 82.7115 61.6821 82.7675 61.6635 82.8272C61.6635 82.8384 61.656 82.8496 61.6523 82.8608C61.6374 82.913 61.6224 82.9652 61.6075 83.0138C61.6075 83.0212 61.6038 83.0287 61.6 83.0362C61.0477 85.0476 61.3164 87.2493 61.5329 88.4136C61.5329 88.4323 61.5403 88.451 61.5441 88.4696C61.5441 88.4734 61.5441 88.4808 61.5441 88.4846C61.5888 88.7122 61.6262 88.895 61.6597 89.0219C61.6672 89.0592 61.6784 89.0928 61.6821 89.119C61.7008 89.1973 61.712 89.2421 61.712 89.2421H61.7194C61.7269 89.2421 61.7381 89.2458 61.7456 89.2496C61.7456 89.2496 61.7456 89.2496 61.753 89.2496C61.7904 89.2608 61.8239 89.2682 61.8613 89.2794C61.9023 89.2906 61.9434 89.3018 61.9844 89.313C62.0367 89.3279 62.0852 89.3391 62.1374 89.3541C62.1747 89.3653 62.2158 89.3727 62.2531 89.3839C62.4397 89.4287 62.6263 89.4697 62.8129 89.5108C62.8464 89.5183 62.8763 89.5257 62.9099 89.5294C62.9659 89.5406 63.0256 89.5518 63.0815 89.563C63.1114 89.5705 63.1413 89.5742 63.1748 89.578C63.3726 89.6153 63.5704 89.6451 63.7719 89.675C63.798 89.675 63.8204 89.6825 63.8466 89.6862C63.9063 89.6936 63.9697 89.7011 64.0294 89.7123C64.0555 89.7123 64.0817 89.7198 64.1115 89.7235C64.313 89.7496 64.5146 89.7683 64.7161 89.7869C64.7385 89.7869 64.7609 89.7907 64.7832 89.7944C64.8429 89.7981 64.9027 89.8056 64.9624 89.8093C64.9885 89.8093 65.0183 89.8131 65.0445 89.8168C65.1042 89.8205 65.1639 89.8243 65.2236 89.828C65.2385 89.828 65.2497 89.828 65.2646 89.828C65.3878 89.8355 65.5109 89.8429 65.6341 89.8466C65.6602 89.8466 65.6826 89.8466 65.7087 89.8466C65.7647 89.8466 65.8244 89.8504 65.8804 89.8541C65.9102 89.8541 65.9401 89.8541 65.9699 89.8541C66.0259 89.8541 66.0856 89.8541 66.1416 89.8578C66.164 89.8578 66.1864 89.8578 66.205 89.8578C66.3207 89.8578 66.4327 89.8616 66.5446 89.8616C66.567 89.8616 66.5894 89.8616 66.6081 89.8616C66.6305 89.8616 66.6491 89.8616 66.6715 89.8616C69.601 89.8616 72.0005 89.3167 72.3252 89.2421C72.3401 89.2421 72.3513 89.2346 72.355 89.2346C72.3849 89.16 72.411 89.0891 72.4371 89.0145C72.4558 88.9585 72.4782 88.9025 72.4968 88.8503C72.4968 88.8428 72.5006 88.8353 72.5043 88.8279C72.5229 88.7719 72.5379 88.7197 72.5565 88.6637C72.5603 88.6525 72.564 88.6376 72.5677 88.6264C72.5864 88.5667 72.6013 88.5107 72.6162 88.451C72.6162 88.451 72.6162 88.4472 72.6162 88.4435C73.3365 85.723 72.3513 82.6406 72.3513 82.6406C71.646 82.4465 70.9481 82.301 70.2764 82.1928"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M40.734 49.0991H83.2277C89.6016 49.0991 94.7664 54.2639 94.7664 60.6378V115.797H29.1953V63.2799"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M76.8657 48.9536V27.9773C76.8657 19.8233 70.2567 13.2144 62.1028 13.2144C53.9488 13.2144 47.3398 19.8233 47.3398 27.9773V34.5825"
                class="accent-stroke"
                stroke-width="6.67055"
                stroke-miterlimit="10" />
            <path
                d="M94.7625 108.916V57.2642C94.7625 52.7563 91.1091 49.0991 86.5974 49.0991H37.3565C32.8485 49.0991 29.1914 52.7525 29.1914 57.2642"
                class="accent-stroke"
                stroke-width="6.67055"
                stroke-miterlimit="10" />
            <path
                d="M93.0506 63.5486C93.4163 63.0224 93.3081 62.2649 92.8155 61.8507C92.3229 61.4364 91.6251 61.5297 91.2631 62.0559C91.2034 62.1418 91.1586 62.2313 91.125 62.3283C91.5056 62.041 92.0356 62.0485 92.4349 62.3806C92.8491 62.7276 92.9872 63.3135 92.808 63.8061C92.9013 63.739 92.9834 63.6531 93.0543 63.5486H93.0506Z"
                class="primary-stroke primary-fill"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M102.602 80.2371L88.6342 68.5791C88.4887 68.4596 88.3805 68.2992 88.3096 68.1163L86.8355 64.1084C86.7086 63.7651 86.7534 63.3807 86.9549 63.0933L90.7464 57.6226C90.7091 57.6599 90.6718 57.7047 90.6382 57.7494L86.5668 63.6195C86.369 63.9069 86.3242 64.2912 86.4474 64.6346L87.9214 68.6425C87.9886 68.8216 88.1006 68.9858 88.2461 69.1052L102.214 80.7633C102.643 81.1216 103.248 81.0432 103.565 80.5842L103.841 80.1849C103.509 80.5245 102.983 80.5543 102.599 80.2334L102.602 80.2371Z"
                class="primary-stroke primary-fill"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M110.261 69.1911C110.69 69.5493 110.784 70.2098 110.466 70.6689L103.954 80.0617C103.637 80.5207 103.033 80.5991 102.603 80.2409L88.6354 68.5828C88.4899 68.4634 88.3817 68.3029 88.3108 68.12L86.8367 64.1121C86.7099 63.7688 86.7546 63.3844 86.9561 63.0971L91.0275 57.227C91.2253 56.9396 91.5537 56.7904 91.8858 56.8314L95.8005 57.3203C95.9796 57.3427 96.1475 57.4173 96.2931 57.5367L110.261 69.1948V69.1911ZM91.5015 63.7539C91.9941 64.1681 92.6919 64.0748 93.0539 63.5486C93.4196 63.0224 93.3114 62.2649 92.8188 61.8507C92.3262 61.4364 91.6283 61.5297 91.2664 62.0559C90.9044 62.5821 91.0089 63.3396 91.5015 63.7539Z"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M72.7414 44.1846C72.6481 44.972 72.5958 46.4199 73.4392 47.935C75.7268 52.0437 81.8469 51.7452 87.3289 56.6375C88.9672 58.1004 90.7435 60.1976 92.1989 63.2838"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M97.0785 66.1534C97.0524 65.7168 97.2128 65.2839 97.5599 64.8585C97.907 64.433 98.295 64.1867 98.7279 64.1233C99.1608 64.0599 99.5713 64.1867 99.9594 64.5002C100.348 64.8137 100.553 65.1906 100.579 65.6309C100.605 66.0713 100.445 66.5004 100.098 66.9259C99.7504 67.3513 99.3623 67.5939 98.9295 67.661C98.4966 67.7245 98.0861 67.6013 97.698 67.2841C97.3099 66.9669 97.1046 66.59 97.0785 66.1534ZM98.7541 66.7318C98.9444 66.6646 99.131 66.5154 99.3176 66.2915C99.5042 66.0676 99.6012 65.8586 99.631 65.6608C99.6609 65.4593 99.5937 65.2951 99.4332 65.1645C99.2728 65.0339 99.0974 65.0003 98.9033 65.0712C98.7093 65.1421 98.5264 65.2839 98.3473 65.5078C98.1682 65.7317 98.0562 65.9481 98.0264 66.1459C97.9965 66.3474 98.0637 66.5116 98.2242 66.646C98.3846 66.7803 98.5637 66.8102 98.7541 66.7393V66.7318ZM102.434 66.5191L103.266 67.1983L95.7462 70.7509L94.9141 70.0718L102.434 66.5191ZM97.6196 71.6466C97.5935 71.2099 97.7539 70.7808 98.101 70.3516C98.4481 69.9225 98.8362 69.6799 99.269 69.6165C99.7019 69.553 100.112 69.6799 100.501 69.9934C100.889 70.3106 101.094 70.6838 101.12 71.1241C101.146 71.5607 100.986 71.9936 100.639 72.419C100.292 72.8445 99.9035 73.0908 99.4706 73.1542C99.0377 73.2176 98.6272 73.0945 98.2391 72.7773C97.851 72.4601 97.6457 72.0832 97.6196 71.6466ZM99.2952 72.225C99.4855 72.1578 99.6721 72.0085 99.8587 71.7809C100.045 71.5533 100.142 71.348 100.172 71.1502C100.202 70.9487 100.135 70.7845 99.9744 70.6539C99.8139 70.5233 99.6348 70.4897 99.4444 70.5606C99.2541 70.6278 99.0675 70.7733 98.8884 70.9935C98.7093 71.2137 98.5973 71.4339 98.5675 71.6354C98.5376 71.8369 98.6048 72.0011 98.7653 72.1317C98.9257 72.2623 99.1011 72.2959 99.2952 72.225Z"
                class="primary-fill" />
            <path
                d="M76.1759 43.1546V27.7909C76.1759 21.3311 70.9403 16.0955 64.4805 16.0955C58.0208 16.0955 52.7852 21.3311 52.7852 27.7909V33.0228"
                class="primary-stroke"
                stroke-width="1.29705"
                stroke-linecap="round"
                stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_11246_15456">
                <rect width="128" height="128" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
